import { useCallback } from 'react';
import SelectBox, {
  Item,
  MultiSelectProps,
  OtherSelectBoxProps,
  SingleSelectProps,
} from '@/components/select/SelectBox';
import { getAllTimezones, getTimezones } from '@/utils/locale/getTimezones';

type TimezoneSelectBoxProps<T extends Item> =
  | (SingleSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple?: false;
        countryCode?: string;
      })
  | (MultiSelectProps<T> &
      OtherSelectBoxProps<T> & {
        multiple: true;
        countryCode?: string;
      });

export interface TimezoneItem {
  id: string;
  name: string;
}

const TimezoneSelectBox = (props: TimezoneSelectBoxProps<TimezoneItem>) => {
  const { label = 'Timezone:', placeholder = 'Select timezone', countryCode } = props;

  const listTimezones = useCallback(async (): Promise<TimezoneItem[]> => {
    if (countryCode === '') {
      throw new Error('Country code is missing');
    }

    const timezones = countryCode ? getTimezones(countryCode) : getAllTimezones();
    return timezones.map((timezoneInfo) => ({
      id: timezoneInfo.name,
      name: timezoneInfo.name,
    }));
  }, [countryCode]);

  return (
    <SelectBox<TimezoneItem>
      {...props}
      name="timezone"
      label={label}
      placeholder={placeholder}
      queryKey={['timezone', String(countryCode)]}
      queryFn={listTimezones}
    />
  );
};

export default TimezoneSelectBox;
